import React, { useEffect } from "react";
import "./styles.less";

export const AuthingCarousel = ({ list, Card }) => {
  useEffect(() => {
    // eslint-disable-next-line no-undef
    new Swiper(".swiper", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      spaceBetween:
        JSON.parse(sessionStorage.getItem("windowWidth")) > 1200 ? 24 : 16,
      slidesPerView:
        JSON.parse(sessionStorage.getItem("windowWidth")) > 768 ? 3 : 2,
      loop: true,
    });
  }, []);
  return (
    <div className="authing-carousel-warp">
      <div class="swiper">
        <div class="swiper-wrapper">
          {list.map((item, index) => {
            return (
              <div class="swiper-slide" key={`item-${index}`}>
                <div className="item" key={`item-${index}`}>
                  <Card item={item} />
                </div>
              </div>
            );
          })}
        </div>
        <div className="arrow-icon-outer-prev swiper-button-prev">
          <div className="arrow-icon-outer">
            <div className="arrow-icon-inner">
              <i className="icon authing-icon authing-arrow-left-s-line"></i>
            </div>
          </div>
        </div>
        <div className="arrow-icon-outer-next swiper-button-next">
          <div className="arrow-icon-outer">
            <div className="arrow-icon-inner">
              <i className="icon authing-icon authing-arrow-right-s-line"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
